<template>
  <div>
      <div class="bgbloco">
          <img src="/sandboxfront/img/framesvg.svg" alt="">
          <div class="letras">
            <p style="font-weight:bold">
             A Lei nº 13.709, de 14 de agosto de 2018, alterada pela Lei nº 13.853, de 08 de julho de 2019, denominada de Lei Geral de Proteção de Dados, com vigência prevista para agosto de 2020, dispõe sobre o tratamento de dados pessoais, inclusive nos meios digitais, por pessoa natural ou por pessoa jurídica de direito público ou privado, com o objetivo de proteger os direitos fundamentais de liberdade e de privacidade e o livre desenvolvimento da personalidade da pessoa natural.
            </p>           
          </div>         
      </div>
    <div class="opcoes">
         <div class="bloco" @click="$router.push({name:'op',params:{id:'1'}})">
                  <img src="/sandboxfront/img/protecao.svg" alt="">
                  <p>Visão Geral</p>
                  <div class="footer">
                        <img src="/sandboxfront/img/seta.svg" alt="">
                  </div>
              </div> 
              <div class="bloco" @click="$router.push({name:'op',params:{id:'2'}})">
                  <img src="/sandboxfront/img/documento.svg" alt="" style="width:49px;">
                  <p>Legislação</p>
                  <div class="footer">
                        <img src="/sandboxfront/img/seta.svg" alt="">
                  </div>
              </div>              
              <div class="bloco" @click="$router.push({name:'op',params:{id:'3'}})">
                  <img src="/sandboxfront/img/brasil2.svg" alt="">
                  <p>Aplicação Federal</p>
                   <div class="footer">
                        <img src="/sandboxfront/img/seta.svg" alt="">
                  </div>
              </div>              
              <div class="bloco"  @click="$router.push({name:'op',params:{id:'4'}})">
                  <img src="/sandboxfront/img/bilhete.svg" alt="">
                  <p>Aplicação Fiscal</p>
                   <div class="footer">
                        <img src="/sandboxfront/img/seta.svg" alt="">
                  </div>
              </div>    
               <div class="bloco"  @click="$router.push({name:'op',params:{id:'5'}})">
                  <img src="/sandboxfront/img/platilha.svg" alt="">
                  <p>Aplicação Trabalhista</p>
                   <div class="footer">
                        <img src="/sandboxfront/img/seta.svg" alt="">
                  </div>
              </div>  
    </div>
    <p txtGeral>LGPD: Lei Geral de Proteção de Dados</p>
    <Apresentacao />    
  </div>
</template>

<script>
import Apresentacao from '../shared/Apresentacao.vue'
export default {
    components:{
        Apresentacao
    },
    data(){
        return{
            opSuH:false
        }
    },
    methods:{
        abrirOpSumario(){
            this.opSuH = !this.opSuH
        }
    }
}
</script>

<style>
a{
    text-decoration: none !important;
    color: #4A154B;
}
.conteudo{
padding:30px;
}

[txtGeral]{
       color: #4A154B;
    font-size: 35px;
    border-bottom: 1px solid #4A154B;
    max-width: 650px;
    width: 100%;
    text-align: center;
    padding-bottom: 6px;
    margin-top: 50px;
    margin: 0 auto;
    font-weight: bold;
    
}
[txtGeral] span{
    font-weight: bold;
}
.bgbloco{
    background: #EDE4ED;
    padding: 80px 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.bgbloco .letras{
    max-width: 700px;
    text-align: justify;
    position: relative;
}
.opcoes{
    width: 100%;
    max-width: 900px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin:0 auto;
    flex-wrap: wrap;
    position: relative;
    top:-50px;
    padding:0px 10px;
}
.opcoes div.bloco .footer{
    background: #4A154B;
border-radius: 0px 0px 7px 7px;
height: 30px;   
width: 100%;
}
.opcoes div.bloco p{
    margin-bottom: 0px;;
}
.opcoes div.bloco{
    cursor: pointer;
    background: #FFFFFF;
border: 1px solid #4A154B;
box-sizing: border-box;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
border-radius: 10px;
width: 155px;
height: 155px;
padding-top:10px;
display: flex;
flex-direction: column;
    align-items: center;
    justify-content: space-between;
flex-wrap: wrap;

color:#4A154B;
font-weight: bold;
text-align: center;
margin-bottom: 10px;
}
tr, td {
    text-align: justify;
    border: 1px solid;    padding: 5px;
}
@media screen and (max-width: 600px) {
    [txtGeral]{
            font-size: 2em;
    }
  .bgbloco{  
    justify-content: center;
    flex-direction: column;
}
.bgbloco img{
    width: 170px;
}
.opcoes{    
    justify-content: space-evenly;
}
}
</style>